import React from "react";
import { useNavigate } from "react-router-dom";
import api from "../utils/api";

const MENTION_REGEX = /(^|[^\w.])@([a-zA-Z0-9_.]{2,32})/g;

export default function MentionText({ text, className = "" }) {
  const navigate = useNavigate();
  const content = String(text || "");
  const parts = [];
  let lastIndex = 0;
  let match;

  while ((match = MENTION_REGEX.exec(content)) !== null) {
    const prefix = match[1] || "";
    const username = match[2];
    const mentionStart = match.index + prefix.length;

    if (mentionStart > lastIndex) {
      parts.push(content.slice(lastIndex, mentionStart));
    }

    parts.push({ username });
    lastIndex = mentionStart + username.length + 1;
  }

  if (lastIndex < content.length) {
    parts.push(content.slice(lastIndex));
  }

  const openMention = async (event, username) => {
    event.preventDefault();
    event.stopPropagation();

    try {
      const { data } = await api.get(`/user/username/${encodeURIComponent(username)}`);
      if (data?.user_uuid) {
        navigate(`/u/${data.user_uuid}`);
      }
    } catch (err) {
      console.error("Could not open mentioned user", err);
    }
  };

  return (
    <span className={className}>
      {parts.map((part, index) =>
        typeof part === "string" ? (
          part
        ) : (
          <button
            key={`${part.username}-${index}`}
            type="button"
            onClick={(event) => openMention(event, part.username)}
            className="inline font-semibold text-orange-600 hover:text-orange-700"
          >
            @{part.username}
          </button>
        )
      )}
    </span>
  );
}
